import styled from 'styled-components';

export const FloatingCloud = styled.img`
    width: 10vw;
    padding: 0 2.5vh;
    height: 5vh;
    position: absolute;
    top: ${props => props.top}; 
    left: ${props => props.left};
    z-index: 3;
`;
